import React, { ForwardedRef, forwardRef } from "react";
import { Button as BsButton, ButtonProps, Spinner } from "react-bootstrap";
import { Icon } from "react-bootstrap-icons";

interface Props extends ButtonProps {
  spinner?: boolean;
  icon?: Icon;
}

export const Button: React.FC<Props> = forwardRef((
  { spinner, icon, children, className, ...props },
  ref: ForwardedRef<HTMLButtonElement>
) => {
  const Icon = icon

  return (
    <BsButton
      className={`d-flex justify-content-center align-items-center ${className ?? ""}`}
      disabled={spinner}
      {...props}
      ref={ref}
    >
      {spinner ? (
        <Spinner animation="grow" size="sm" className={children ? "me-2" : ""} />
      ) : Icon && (
        <Icon className={children ? "me-2" : ""} />
      )}
      {children}
    </BsButton>
  )
});
